import { Box, HStack, HStackProps } from '@rbilabs/universal-components';

import { theme } from 'styles/configure-theme';
import { primitive } from 'styles/constants/primitives';
import { WEB_APP_CTA_MAX_WIDTH } from 'utils/constants';

export const displayValueStyleProps = () => ({
  background: 'transparent',
  minWidth: 5,
  width: 5,
  _text: {
    fontSize: 18,
  },
});

export const incrementorStyleProps = ({ disabled }: { disabled?: boolean }) => ({
  padding: 1,
  borderRadius: 20,
  borderWidth: 1,
  margin: 0.5,
  borderColor: theme.token(disabled ? 'icon-disabled' : 'icon-default'),
  _icon: {
    color: theme.token(disabled ? 'icon-disabled' : 'icon-default'),
    size: 6,
  },
});

export const footerWrapperProps: HStackProps = {
  _android: {
    style: {
      elevation: 10,
    },
  },
};

export const ActionsWrapper = Box.withConfig({
  width: 'full',
  paddingX: { base: '$4', md: 0 },
  flexDirection: 'row',
  justifyContent: 'space-between',
  maxWidth: WEB_APP_CTA_MAX_WIDTH,
});

// Footer Styles
export const BoxChild = Box.withConfig<{ lastChild: boolean; spaces?: number }>(p => ({
  alignItems: 'center',
  justifyContent: 'center',
  flex: p.spaces || 1,
  marginRight: p.lastChild ? 0 : 4,
}));

export const FooterWrapper = HStack.withConfig({
  borderTopWidth: 1,
  borderTopColor: primitive.$blackOpacity4,
  safeAreaBottom: true,
  width: 'full',
  background: theme.token('background-pattern'),
  paddingY: '$6',
  _ios: {
    paddingY: 0,
    paddingTop: '$6',
  },
});
